import {Button} from 'react-aria-components'
import LogoutDialog from 'src/auth/components/LogoutDialog'
import ThemeSwitcher from 'src/components/ThemeSwitcher/ThemeSwitcher'
import BookmarkLink from 'src/layout/BookmarkLink'
import HeadTags from 'src/lib/head/HeadTags'
import CountrySelector from 'src/lib/locale/components/CountrySelector'
import {
  AddressesRoute,
  FlightsRoute,
  FoodOrdersRoute,
  InternalMenuRoute,
  OrdersRoute,
  ProfileRoute,
  RewardsRoute,
  SignInRoute,
} from 'src/routeRegistry'

import AeroplaneSvg from '@/assets/flight/icons/aeroplane.svg?react'
import DeliveryTruckSvg from '@/assets/food/icons/delivery-truck.svg?react'
import LogoutSvg from '@/assets/icons/logout.svg?react'
import AddressSvg from '@/assets/icons/manage-address.svg?react'
import OrderSvg from '@/assets/icons/order.svg?react'
import RewardsSvg from '@/assets/icons/rewards.svg?react'
import UserSvg from '@/assets/icons/user.svg?react'
import {useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'

import style from './Menu.module.scss'

export default function Menu() {
  const isAuthenticated = useIsAuthenticatedValue()

  const {fullPath: internalMenuFullPath} = useMatch({from: InternalMenuRoute.id})

  return (
    <>
      <HeadTags title='Profile' />
      <div className={style.Menu}>
        {isAuthenticated ? (
          <>
            <Link to={ProfileRoute.fullPath} className={style.RightMenuItem}>
              <UserSvg className={style.Icon} aria-hidden />
              Profile
            </Link>
            <Link to={OrdersRoute.fullPath} className={style.RightMenuItem}>
              <OrderSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
              Orders
            </Link>
            <Link to={FlightsRoute.fullPath} className={style.RightMenuItem}>
              <AeroplaneSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
              Flights
            </Link>
            <Link to={FoodOrdersRoute.fullPath} className={style.RightMenuItem}>
              <DeliveryTruckSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
              Food Orders
            </Link>
            <Link to={RewardsRoute.fullPath} className={style.RightMenuItem}>
              <RewardsSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
              Rewards
            </Link>
            <Link to={AddressesRoute.fullPath} className={style.RightMenuItem}>
              <AddressSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
              Addresses
            </Link>
          </>
        ) : (
          <Link
            to={SignInRoute.fullPath}
            search={{
              redirect: internalMenuFullPath,
            }}
            className={style.RightMenuItem}
          >
            <UserSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
            Sign in
          </Link>
        )}
        <BookmarkLink className={style.RightMenuItem} svgClassName={style.Icon} />
        {/* <div className={style.RightMenuItem}>
                  <img src={history} alt='' />
                  History
                </div> */}
        {/* <div className={style.RightMenuItem}>
                  <span aria-hidden>Country</span>
                  <CountrySelector />
                </div> */}
        <div className={clsx(style.RightMenuItem, style.SmallMenuItem)}>
          <span aria-hidden>Appearance</span>
          <ThemeSwitcher />
        </div>
        <div className={clsx(style.RightMenuItem, style.SmallMenuItem)}>
          <span aria-hidden>Country</span>
          <CountrySelector />
        </div>
        {isAuthenticated && (
          <LogoutDialog>
            <Button className={clsx(style.RightMenuItem, style.Logout)}>
              <LogoutSvg aria-hidden />
              Logout
            </Button>
          </LogoutDialog>
        )}
      </div>
    </>
  )
}
